// index.tsx
import React from 'react';
import { createRoot } from "react-dom/client";
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { CssBaseline, ThemeProvider, StyledEngineProvider } from "@mui/material";
import { MuiTheme } from './ui/global/GlobalStyles';
import { HelmetProvider } from 'react-helmet-async';
import posthog from './utils/analytics';
import { PostHogProvider } from 'posthog-js/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
    },
  },
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
    <HelmetProvider>
      <PostHogProvider client={posthog}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={MuiTheme}>
                <CssBaseline />
                <App />
              </ThemeProvider>
            </StyledEngineProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </PostHogProvider>
    </HelmetProvider>
);